import moment from 'moment';

export const getIsRegistrationPeriod = (
  registrationStartDate: string | null,
  registrationEndDate: string | null,
) => {
  if (!registrationStartDate || !registrationEndDate) {
    return false;
  }

  const currentEpoch = moment().unix();
  const registrationStartEpoch = moment(registrationStartDate).unix();
  const registrationEndEpoch = moment(registrationEndDate).unix();
  return currentEpoch > registrationStartEpoch && currentEpoch < registrationEndEpoch;
};
